import * as React from "react";
import { BooleanInput, FormDataConsumer } from 'react-admin';

const HomeSectionMarquee = ({ isCreate = false }) => (
    <FormDataConsumer>
        {({ formData }) => {
            if (formData?.isCarousel) return null;

            return (
                <React.Fragment>
                    <BooleanInput
                        label="Use marquee scrolling?"
                        source="marquee"
                        defaultValue={isCreate ? false : undefined}
                    />
                    <span style={{ fontSize: 12, display: 'block', marginTop: -8, marginBottom: 16 }}>
                        Events scroll continuously from right to left when more than 4 events are displayed.
                    </span>
                </React.Fragment>
            );
        }}
    </FormDataConsumer>
);

export default HomeSectionMarquee;
